import "./login.2d35ad47.js";
import "./firebase-init-vp.9a246ac5.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree555"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree555"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dCqD9", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");

var $hPtJY = parcelRequire("hPtJY");
window.Buffer = (0, $6ZWSX.Buffer);
window.process = (0, (/*@__PURE__*/$parcel$interopDefault($hPtJY)));

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRequire("dCqD9");

var $bhHFP = parcelRequire("bhHFP");

var $ilpIi = parcelRequire("ilpIi");
/* =========================
   CONFIG DINÂMICA
========================= */ const $2a5271524fdbb73b$var$BODY = document.body;
const $2a5271524fdbb73b$var$CONFIG = {
    territoryId: String($2a5271524fdbb73b$var$BODY.dataset.territoryId || "").trim(),
    territoryLabel: String($2a5271524fdbb73b$var$BODY.dataset.territoryLabel || "").trim(),
    territorySlug: String($2a5271524fdbb73b$var$BODY.dataset.territorySlug || "").trim(),
    redirectAfterSuccess: String($2a5271524fdbb73b$var$BODY.dataset.redirectUrl || "index.html").trim(),
    viacepBase: "https://viacep.com.br/ws",
    nominatimBase: "https://nominatim.openstreetmap.org/search"
};
const $2a5271524fdbb73b$var$CODE_CONFIG = {
    "vila-pinto": {
        casa: {
            prefix: "VPD",
            start: 300
        },
        condominio: {
            prefix: "VPCD",
            start: 10
        },
        comercio: {
            prefix: "VPCM",
            start: 10
        },
        outro: {
            prefix: "VPO",
            start: 300
        }
    },
    "cooadesc": {
        casa: {
            prefix: "COD",
            start: 1
        },
        condominio: {
            prefix: "COCD",
            start: 1
        },
        comercio: {
            prefix: "COCM",
            start: 1
        },
        outro: {
            prefix: "COO",
            start: 1
        }
    },
    "padre-cacique": {
        casa: {
            prefix: "PCD",
            start: 1
        },
        condominio: {
            prefix: "PCCD",
            start: 1
        },
        comercio: {
            prefix: "PCCM",
            start: 1
        },
        outro: {
            prefix: "PCO",
            start: 1
        }
    }
};
/* =========================
   STATE
========================= */ const $2a5271524fdbb73b$var$STATE = {
    currentStep: 1,
    totalSteps: 4,
    localType: "casa",
    registerType: "participante",
    generatedCode: "",
    consentAccepted: false,
    isSubmitting: false,
    geoRequestId: 0,
    geo: {
        lat: null,
        lng: null,
        addressLabel: ""
    }
};
/* =========================
   ELEMENTOS
========================= */ const $2a5271524fdbb73b$var$$ = (id)=>document.getElementById(id);
const $2a5271524fdbb73b$var$els = {
    form: $2a5271524fdbb73b$var$$("participantWizardForm"),
    formMessage: $2a5271524fdbb73b$var$$("formMessage"),
    stepIndicator: $2a5271524fdbb73b$var$$("stepIndicator"),
    progressText: $2a5271524fdbb73b$var$$("progressText"),
    progressBarFill: $2a5271524fdbb73b$var$$("progressBarFill"),
    territoryLabelView: $2a5271524fdbb73b$var$$("territoryLabelView"),
    userNameView: $2a5271524fdbb73b$var$$("userNameView"),
    consentLgpd: $2a5271524fdbb73b$var$$("consentLgpd"),
    consentWhatsapp: $2a5271524fdbb73b$var$$("consentWhatsapp"),
    consentImage: $2a5271524fdbb73b$var$$("consentImage"),
    btnAcceptAllConsents: $2a5271524fdbb73b$var$$("btnAcceptAllConsents"),
    consentAcceptedNote: $2a5271524fdbb73b$var$$("consentAcceptedNote"),
    fullName: $2a5271524fdbb73b$var$$("fullName"),
    phone: $2a5271524fdbb73b$var$$("phone"),
    email: $2a5271524fdbb73b$var$$("email"),
    cpf: $2a5271524fdbb73b$var$$("cpf"),
    localTypeGroup: $2a5271524fdbb73b$var$$("localTypeGroup"),
    registerTypeGroup: $2a5271524fdbb73b$var$$("registerTypeGroup"),
    generatedCode: $2a5271524fdbb73b$var$$("generatedCode"),
    cep: $2a5271524fdbb73b$var$$("cep"),
    btnBuscarCep: $2a5271524fdbb73b$var$$("btnBuscarCep"),
    number: $2a5271524fdbb73b$var$$("number"),
    street: $2a5271524fdbb73b$var$$("street"),
    neighborhood: $2a5271524fdbb73b$var$$("neighborhood"),
    city: $2a5271524fdbb73b$var$$("city"),
    state: $2a5271524fdbb73b$var$$("state"),
    referencePoint: $2a5271524fdbb73b$var$$("referencePoint"),
    geoPreview: $2a5271524fdbb73b$var$$("geoPreview"),
    latLngPreview: $2a5271524fdbb73b$var$$("latLngPreview"),
    difficultyGroup: $2a5271524fdbb73b$var$$("difficultyGroup"),
    householdMembers: $2a5271524fdbb73b$var$$("householdMembers"),
    projectSource: $2a5271524fdbb73b$var$$("projectSource"),
    projectSourceOther: $2a5271524fdbb73b$var$$("projectSourceOther"),
    successModal: $2a5271524fdbb73b$var$$("successModal"),
    closeSuccessModal: $2a5271524fdbb73b$var$$("closeSuccessModal"),
    newParticipantRegistration: $2a5271524fdbb73b$var$$("newParticipantRegistration"),
    menuToggle: $2a5271524fdbb73b$var$$("menuToggle"),
    mobileMenu: $2a5271524fdbb73b$var$$("mobileMenu"),
    btnSubmitParticipant: $2a5271524fdbb73b$var$$("btnSubmitParticipant")
};
/* =========================
   HELPERS
========================= */ function $2a5271524fdbb73b$var$onlyDigits(value = "") {
    return String(value).replace(/\D/g, "");
}
function $2a5271524fdbb73b$var$slugify(value = "") {
    return String(value).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().replace(/\s+/g, "-");
}
function $2a5271524fdbb73b$var$normalizeName(name = "") {
    return String(name).normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().replace(/\s+/g, " ");
}
function $2a5271524fdbb73b$var$capitalizeWords(text = "") {
    return String(text).toLowerCase().replace(/\b\w/g, (m)=>m.toUpperCase());
}
function $2a5271524fdbb73b$var$showMessage(message, type = "info") {
    if (!$2a5271524fdbb73b$var$els.formMessage) return;
    $2a5271524fdbb73b$var$els.formMessage.classList.remove("hidden", "error", "success", "info", "warning");
    $2a5271524fdbb73b$var$els.formMessage.classList.add(type);
    $2a5271524fdbb73b$var$els.formMessage.textContent = message;
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
}
function $2a5271524fdbb73b$var$clearMessage() {
    if (!$2a5271524fdbb73b$var$els.formMessage) return;
    $2a5271524fdbb73b$var$els.formMessage.classList.add("hidden");
    $2a5271524fdbb73b$var$els.formMessage.textContent = "";
    $2a5271524fdbb73b$var$els.formMessage.classList.remove("error", "success", "info", "warning");
}
function $2a5271524fdbb73b$var$setLoading(button, isLoading, loadingText = "Salvando...") {
    if (!button) return;
    if (isLoading) {
        if (!button.dataset.originalText) button.dataset.originalText = button.textContent;
        button.disabled = true;
        button.textContent = loadingText;
    } else {
        button.disabled = false;
        button.textContent = button.dataset.originalText || "Salvar";
    }
}
function $2a5271524fdbb73b$var$formatPhone(value = "") {
    const digits = $2a5271524fdbb73b$var$onlyDigits(value).slice(0, 11);
    if (digits.length <= 2) return digits;
    if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}
function $2a5271524fdbb73b$var$formatCPF(value = "") {
    const digits = $2a5271524fdbb73b$var$onlyDigits(value).slice(0, 11);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
    if (digits.length <= 9) return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9, 11)}`;
}
function $2a5271524fdbb73b$var$formatCEP(value = "") {
    const digits = $2a5271524fdbb73b$var$onlyDigits(value).slice(0, 8);
    if (digits.length <= 5) return digits;
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}
function $2a5271524fdbb73b$var$isValidEmail(email = "") {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).trim());
}
function $2a5271524fdbb73b$var$isValidCPF(cpf = "") {
    const digits = $2a5271524fdbb73b$var$onlyDigits(cpf);
    if (!digits) return true;
    if (digits.length !== 11) return false;
    if (/^(\d)\1+$/.test(digits)) return false;
    let sum = 0;
    for(let i = 0; i < 9; i++)sum += Number(digits[i]) * (10 - i);
    let firstDigit = sum * 10 % 11;
    if (firstDigit === 10) firstDigit = 0;
    if (firstDigit !== Number(digits[9])) return false;
    sum = 0;
    for(let i = 0; i < 10; i++)sum += Number(digits[i]) * (11 - i);
    let secondDigit = sum * 10 % 11;
    if (secondDigit === 10) secondDigit = 0;
    if (secondDigit !== Number(digits[10])) return false;
    return true;
}
/* =========================
   CONFIG AUXILIAR
========================= */ function $2a5271524fdbb73b$var$getCanonicalTerritoryId() {
    return $2a5271524fdbb73b$var$CONFIG.territoryId;
}
function $2a5271524fdbb73b$var$getCanonicalTerritoryLabel() {
    return $2a5271524fdbb73b$var$CONFIG.territoryLabel;
}
function $2a5271524fdbb73b$var$getCodeTerritoryKey() {
    return String($2a5271524fdbb73b$var$CONFIG.territorySlug || $2a5271524fdbb73b$var$CONFIG.territoryId || "").toLowerCase().replace(/^crgr_/, "").replace(/_/g, "-").trim();
}
function $2a5271524fdbb73b$var$getCodeLocalType() {
    const localType = String($2a5271524fdbb73b$var$STATE.localType || "casa").trim();
    if (localType === "condominio") return "condominio";
    if (localType === "comercio") return "comercio";
    if (localType === "outro") return "outro";
    return "casa";
}
function $2a5271524fdbb73b$var$assertRuntimeConfig() {
    if (!$2a5271524fdbb73b$var$CONFIG.territoryId || !$2a5271524fdbb73b$var$CONFIG.territoryLabel) throw new Error("Configura\xe7\xe3o do territ\xf3rio ausente. Verifique os atributos data-territory-id e data-territory-label no body.");
}
/* =========================
   CÓDIGO SEQUENCIAL
========================= */ async function $2a5271524fdbb73b$var$generateSequentialCode() {
    const territoryKey = $2a5271524fdbb73b$var$getCodeTerritoryKey();
    const localTypeKey = $2a5271524fdbb73b$var$getCodeLocalType();
    const config = $2a5271524fdbb73b$var$CODE_CONFIG[territoryKey]?.[localTypeKey];
    if (!config) throw new Error(`Configura\xe7\xe3o de c\xf3digo n\xe3o encontrada para ${territoryKey}/${localTypeKey}.`);
    const { prefix: prefix, start: start } = config;
    const q = (0, $ilpIi.query)((0, $ilpIi.collection)((0, $bhHFP.db), "participants"), (0, $ilpIi.where)("territoryId", "==", $2a5271524fdbb73b$var$getCanonicalTerritoryId()), (0, $ilpIi.where)("codeLocalType", "==", localTypeKey));
    const snapshot = await (0, $ilpIi.getDocs)(q);
    let maxNumber = 0;
    snapshot.forEach((docSnap)=>{
        const data = docSnap.data() || {};
        const code = String(data.participantCode || "").trim();
        if (!code.startsWith(`${prefix}-`)) return;
        const numberPart = Number(code.split("-")[1]);
        if (Number.isFinite(numberPart) && numberPart > maxNumber) maxNumber = numberPart;
    });
    const nextNumber = Math.max(start, maxNumber + 1);
    return `${prefix}-${String(nextNumber).padStart(4, "0")}`;
}
function $2a5271524fdbb73b$var$getRegisterTypeByLocalType(localType) {
    return localType === "condominio" ? "condominio" : "participante";
}
/* =========================
   GEO PREVIEW
========================= */ function $2a5271524fdbb73b$var$updateGeoPreview() {
    if ($2a5271524fdbb73b$var$els.geoPreview) $2a5271524fdbb73b$var$els.geoPreview.textContent = $2a5271524fdbb73b$var$STATE.geo.addressLabel || "ainda n\xe3o calculado";
    if ($2a5271524fdbb73b$var$els.latLngPreview) {
        if ($2a5271524fdbb73b$var$STATE.geo.lat != null && $2a5271524fdbb73b$var$STATE.geo.lng != null) $2a5271524fdbb73b$var$els.latLngPreview.textContent = `${$2a5271524fdbb73b$var$STATE.geo.lat}, ${$2a5271524fdbb73b$var$STATE.geo.lng}`;
        else $2a5271524fdbb73b$var$els.latLngPreview.textContent = "ainda n\xe3o calculado";
    }
}
function $2a5271524fdbb73b$var$resetGeo() {
    $2a5271524fdbb73b$var$STATE.geo = {
        lat: null,
        lng: null,
        addressLabel: ""
    };
    $2a5271524fdbb73b$var$updateGeoPreview();
}
/* =========================
   TIPO DE LOCAL / CÓDIGO
========================= */ function $2a5271524fdbb73b$var$syncRegisterTypeUI() {
    const buttons = $2a5271524fdbb73b$var$els.registerTypeGroup?.querySelectorAll("[data-register-type]") || [];
    buttons.forEach((btn)=>{
        const registerType = btn.dataset.registerType;
        const isSelected = registerType === $2a5271524fdbb73b$var$STATE.registerType;
        const shouldBeDisabled = $2a5271524fdbb73b$var$STATE.localType === "condominio" ? registerType !== "condominio" : registerType === "condominio";
        btn.classList.toggle("selected", isSelected);
        btn.classList.toggle("is-disabled", shouldBeDisabled);
        btn.setAttribute("aria-pressed", isSelected ? "true" : "false");
    });
}
async function $2a5271524fdbb73b$var$setRegisterType(registerType, regenerate = true) {
    $2a5271524fdbb73b$var$STATE.registerType = registerType;
    if (regenerate || !$2a5271524fdbb73b$var$STATE.generatedCode) $2a5271524fdbb73b$var$STATE.generatedCode = await $2a5271524fdbb73b$var$generateSequentialCode();
    if ($2a5271524fdbb73b$var$els.generatedCode) $2a5271524fdbb73b$var$els.generatedCode.value = $2a5271524fdbb73b$var$STATE.generatedCode;
    $2a5271524fdbb73b$var$syncRegisterTypeUI();
}
async function $2a5271524fdbb73b$var$setLocalType(localType) {
    $2a5271524fdbb73b$var$STATE.localType = localType;
    const buttons = $2a5271524fdbb73b$var$els.localTypeGroup?.querySelectorAll("[data-local-type]") || [];
    buttons.forEach((btn)=>{
        const selected = btn.dataset.localType === localType;
        btn.classList.toggle("selected", selected);
        btn.setAttribute("aria-pressed", selected ? "true" : "false");
    });
    const autoRegisterType = $2a5271524fdbb73b$var$getRegisterTypeByLocalType(localType);
    try {
        await $2a5271524fdbb73b$var$setRegisterType(autoRegisterType, true);
    } catch (error) {
        console.warn("N\xe3o foi poss\xedvel gerar o c\xf3digo neste momento:", error);
        if ($2a5271524fdbb73b$var$els.generatedCode) $2a5271524fdbb73b$var$els.generatedCode.value = "Ser\xe1 gerado ao concluir";
    }
}
/* =========================
   STEPS
========================= */ function $2a5271524fdbb73b$var$getStepCards() {
    return Array.from(document.querySelectorAll(".step-card"));
}
function $2a5271524fdbb73b$var$updateProgress() {
    if ($2a5271524fdbb73b$var$els.stepIndicator) $2a5271524fdbb73b$var$els.stepIndicator.textContent = `Etapa ${$2a5271524fdbb73b$var$STATE.currentStep} de ${$2a5271524fdbb73b$var$STATE.totalSteps}`;
    if ($2a5271524fdbb73b$var$els.progressText) $2a5271524fdbb73b$var$els.progressText.textContent = `Progresso: ${$2a5271524fdbb73b$var$STATE.currentStep}/${$2a5271524fdbb73b$var$STATE.totalSteps}`;
    if ($2a5271524fdbb73b$var$els.progressBarFill) {
        const pct = $2a5271524fdbb73b$var$STATE.currentStep / $2a5271524fdbb73b$var$STATE.totalSteps * 100;
        $2a5271524fdbb73b$var$els.progressBarFill.style.width = `${pct}%`;
    }
    $2a5271524fdbb73b$var$getStepCards().forEach((card)=>{
        const step = Number(card.dataset.step);
        const isActive = step === $2a5271524fdbb73b$var$STATE.currentStep;
        card.classList.toggle("is-active", isActive);
        card.classList.toggle("hidden", !isActive);
    });
}
function $2a5271524fdbb73b$var$goToStep(step) {
    if (step < 1 || step > $2a5271524fdbb73b$var$STATE.totalSteps) return;
    $2a5271524fdbb73b$var$STATE.currentStep = step;
    $2a5271524fdbb73b$var$updateProgress();
    $2a5271524fdbb73b$var$clearMessage();
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
}
/* =========================
   VALIDAÇÃO
========================= */ function $2a5271524fdbb73b$var$validateStep1() {
    if (!$2a5271524fdbb73b$var$STATE.consentAccepted) {
        $2a5271524fdbb73b$var$showMessage("Para continuar, clique em \u201CConcordo com todas as autoriza\xe7\xf5es\u201D.", "error");
        $2a5271524fdbb73b$var$els.btnAcceptAllConsents?.focus();
        return false;
    }
    return true;
}
function $2a5271524fdbb73b$var$validateStep2() {
    const fullName = $2a5271524fdbb73b$var$normalizeName($2a5271524fdbb73b$var$els.fullName?.value);
    const phone = $2a5271524fdbb73b$var$onlyDigits($2a5271524fdbb73b$var$els.phone?.value);
    const email = String($2a5271524fdbb73b$var$els.email?.value || "").trim();
    const cpf = String($2a5271524fdbb73b$var$els.cpf?.value || "").trim();
    if (!fullName || fullName.length < 5) {
        $2a5271524fdbb73b$var$showMessage("Informe o nome completo corretamente.", "error");
        $2a5271524fdbb73b$var$els.fullName?.focus();
        return false;
    }
    if (phone.length < 10 || phone.length > 11) {
        $2a5271524fdbb73b$var$showMessage("Informe um telefone/WhatsApp v\xe1lido com DDD.", "error");
        $2a5271524fdbb73b$var$els.phone?.focus();
        return false;
    }
    if (email && !$2a5271524fdbb73b$var$isValidEmail(email)) {
        $2a5271524fdbb73b$var$showMessage("O e-mail informado n\xe3o \xe9 v\xe1lido. Corrija ou deixe o campo em branco.", "error");
        $2a5271524fdbb73b$var$els.email?.focus();
        return false;
    }
    if (cpf && !$2a5271524fdbb73b$var$isValidCPF(cpf)) {
        $2a5271524fdbb73b$var$showMessage("O CPF informado n\xe3o \xe9 v\xe1lido. Corrija ou deixe o campo em branco.", "error");
        $2a5271524fdbb73b$var$els.cpf?.focus();
        return false;
    }
    return true;
}
function $2a5271524fdbb73b$var$validateStep3() {
    const referencePoint = String($2a5271524fdbb73b$var$els.referencePoint?.value || "").trim();
    if (!referencePoint) {
        $2a5271524fdbb73b$var$showMessage("Informe o ponto de refer\xeancia.", "error");
        $2a5271524fdbb73b$var$els.referencePoint?.focus();
        return false;
    }
    return true;
}
function $2a5271524fdbb73b$var$validateStep4() {
    return true;
}
function $2a5271524fdbb73b$var$validateCurrentStep() {
    switch($2a5271524fdbb73b$var$STATE.currentStep){
        case 1:
            return $2a5271524fdbb73b$var$validateStep1();
        case 2:
            return $2a5271524fdbb73b$var$validateStep2();
        case 3:
            return $2a5271524fdbb73b$var$validateStep3();
        case 4:
            return $2a5271524fdbb73b$var$validateStep4();
        default:
            return true;
    }
}
/* =========================
   CEP + GEO
========================= */ async function $2a5271524fdbb73b$var$fetchCEP(cep) {
    const cleanCep = $2a5271524fdbb73b$var$onlyDigits(cep);
    if (cleanCep.length !== 8) throw new Error("CEP inv\xe1lido.");
    const url = `${$2a5271524fdbb73b$var$CONFIG.viacepBase}/${cleanCep}/json/`;
    const response = await fetch(url);
    if (!response.ok) throw new Error("Falha ao consultar o CEP.");
    const data = await response.json();
    if (data.erro) throw new Error("CEP n\xe3o encontrado.");
    return data;
}
async function $2a5271524fdbb73b$var$geocodeAddress() {
    const street = String($2a5271524fdbb73b$var$els.street?.value || "").trim();
    const number = String($2a5271524fdbb73b$var$els.number?.value || "").trim();
    const neighborhood = String($2a5271524fdbb73b$var$els.neighborhood?.value || "").trim();
    const city = String($2a5271524fdbb73b$var$els.city?.value || "").trim();
    const state = String($2a5271524fdbb73b$var$els.state?.value || "").trim();
    const cep = $2a5271524fdbb73b$var$onlyDigits($2a5271524fdbb73b$var$els.cep?.value);
    if (!street || !number || !city || !state) return null;
    const queryText = `${street}, ${number}, ${neighborhood}, ${city}, ${state}, Brasil, ${cep}`;
    const url = new URL($2a5271524fdbb73b$var$CONFIG.nominatimBase);
    url.searchParams.set("format", "jsonv2");
    url.searchParams.set("limit", "1");
    url.searchParams.set("countrycodes", "br");
    url.searchParams.set("q", queryText);
    const response = await fetch(url.toString(), {
        headers: {
            Accept: "application/json"
        }
    });
    if (!response.ok) throw new Error("Falha ao geocodificar endere\xe7o.");
    const results = await response.json();
    if (!Array.isArray(results) || !results.length) return null;
    const result = results[0];
    return {
        lat: Number(result.lat),
        lng: Number(result.lon),
        addressLabel: result.display_name || queryText
    };
}
async function $2a5271524fdbb73b$var$handleBuscarCep() {
    $2a5271524fdbb73b$var$clearMessage();
    try {
        const data = await $2a5271524fdbb73b$var$fetchCEP($2a5271524fdbb73b$var$els.cep?.value || "");
        if ($2a5271524fdbb73b$var$els.street) $2a5271524fdbb73b$var$els.street.value = data.logradouro || "";
        if ($2a5271524fdbb73b$var$els.neighborhood) $2a5271524fdbb73b$var$els.neighborhood.value = data.bairro || "";
        if ($2a5271524fdbb73b$var$els.city) $2a5271524fdbb73b$var$els.city.value = data.localidade || "";
        if ($2a5271524fdbb73b$var$els.state) $2a5271524fdbb73b$var$els.state.value = data.uf || "";
        $2a5271524fdbb73b$var$showMessage("CEP encontrado com sucesso.", "success");
        await $2a5271524fdbb73b$var$tryGeocodeWhenReady(true);
    } catch (error) {
        $2a5271524fdbb73b$var$resetGeo();
        $2a5271524fdbb73b$var$showMessage(error.message || "N\xe3o foi poss\xedvel buscar o CEP.", "error");
    }
}
async function $2a5271524fdbb73b$var$tryGeocodeWhenReady(force = false) {
    const requiredReady = String($2a5271524fdbb73b$var$els.street?.value || "").trim() && String($2a5271524fdbb73b$var$els.number?.value || "").trim() && String($2a5271524fdbb73b$var$els.city?.value || "").trim() && String($2a5271524fdbb73b$var$els.state?.value || "").trim();
    if (!requiredReady) {
        if (force) $2a5271524fdbb73b$var$resetGeo();
        return;
    }
    const requestId = ++$2a5271524fdbb73b$var$STATE.geoRequestId;
    try {
        const geo = await $2a5271524fdbb73b$var$geocodeAddress();
        if (requestId !== $2a5271524fdbb73b$var$STATE.geoRequestId) return;
        $2a5271524fdbb73b$var$STATE.geo = geo || {
            lat: null,
            lng: null,
            addressLabel: ""
        };
        $2a5271524fdbb73b$var$updateGeoPreview();
    } catch  {
        if (requestId !== $2a5271524fdbb73b$var$STATE.geoRequestId) return;
        $2a5271524fdbb73b$var$resetGeo();
    }
}
/* =========================
   PAYLOAD
========================= */ function $2a5271524fdbb73b$var$getSelectedDifficulty() {
    return $2a5271524fdbb73b$var$els.difficultyGroup?.querySelector(".choice-card.selected")?.dataset?.difficulty || "sim";
}
function $2a5271524fdbb73b$var$getProjectSourceLabel() {
    if (!$2a5271524fdbb73b$var$els.projectSource) return null;
    const selectedOption = $2a5271524fdbb73b$var$els.projectSource.options[$2a5271524fdbb73b$var$els.projectSource.selectedIndex];
    return selectedOption?.textContent?.trim() || null;
}
function $2a5271524fdbb73b$var$buildAddressLabel() {
    const cepDigits = $2a5271524fdbb73b$var$onlyDigits($2a5271524fdbb73b$var$els.cep?.value || "");
    const street = String($2a5271524fdbb73b$var$els.street?.value || "").trim();
    const number = String($2a5271524fdbb73b$var$els.number?.value || "").trim();
    const neighborhood = String($2a5271524fdbb73b$var$els.neighborhood?.value || "").trim();
    const city = String($2a5271524fdbb73b$var$els.city?.value || "").trim();
    const state = String($2a5271524fdbb73b$var$els.state?.value || "").trim().toUpperCase();
    const referencePoint = String($2a5271524fdbb73b$var$els.referencePoint?.value || "").trim();
    const enderecoCompleto = [
        street && number ? `${street}, ${number}` : street || number,
        neighborhood,
        city || state ? `${city}${city && state ? ", " : ""}${state}` : "",
        cepDigits ? `CEP ${$2a5271524fdbb73b$var$formatCEP(cepDigits)}` : "",
        "Brasil"
    ].filter(Boolean).join(" - ");
    return enderecoCompleto || referencePoint;
}
function $2a5271524fdbb73b$var$buildParticipantPayload() {
    const territoryId = $2a5271524fdbb73b$var$getCanonicalTerritoryId();
    const territoryLabel = $2a5271524fdbb73b$var$getCanonicalTerritoryLabel();
    const fullName = $2a5271524fdbb73b$var$capitalizeWords($2a5271524fdbb73b$var$normalizeName($2a5271524fdbb73b$var$els.fullName?.value || ""));
    const phoneDigits = $2a5271524fdbb73b$var$onlyDigits($2a5271524fdbb73b$var$els.phone?.value || "");
    const email = String($2a5271524fdbb73b$var$els.email?.value || "").trim().toLowerCase();
    const cpfDigits = $2a5271524fdbb73b$var$onlyDigits($2a5271524fdbb73b$var$els.cpf?.value || "");
    const cepDigits = $2a5271524fdbb73b$var$onlyDigits($2a5271524fdbb73b$var$els.cep?.value || "");
    const street = String($2a5271524fdbb73b$var$els.street?.value || "").trim();
    const number = String($2a5271524fdbb73b$var$els.number?.value || "").trim();
    const neighborhood = String($2a5271524fdbb73b$var$els.neighborhood?.value || "").trim();
    const city = String($2a5271524fdbb73b$var$els.city?.value || "").trim();
    const state = String($2a5271524fdbb73b$var$els.state?.value || "").trim().toUpperCase();
    const referencePoint = String($2a5271524fdbb73b$var$els.referencePoint?.value || "").trim();
    const difficulty = $2a5271524fdbb73b$var$getSelectedDifficulty();
    const householdMembers = String($2a5271524fdbb73b$var$els.householdMembers?.value || "").trim();
    const projectSource = String($2a5271524fdbb73b$var$els.projectSource?.value || "").trim() || null;
    const projectSourceLabel = $2a5271524fdbb73b$var$getProjectSourceLabel();
    const projectSourceOther = String($2a5271524fdbb73b$var$els.projectSourceOther?.value || "").trim() || null;
    return {
        name: fullName,
        fullName: fullName,
        nameLower: $2a5271524fdbb73b$var$slugify(fullName),
        phone: phoneDigits,
        email: email || null,
        cpf: cpfDigits || null,
        localType: $2a5271524fdbb73b$var$STATE.localType,
        codeLocalType: $2a5271524fdbb73b$var$getCodeLocalType(),
        registerType: $2a5271524fdbb73b$var$STATE.registerType,
        participantType: $2a5271524fdbb73b$var$STATE.registerType,
        participantCode: $2a5271524fdbb73b$var$STATE.generatedCode,
        cep: cepDigits || null,
        rua: street || null,
        street: street || null,
        numero: number || null,
        neighborhood: neighborhood || null,
        bairro: neighborhood || null,
        city: city || null,
        cidade: city || null,
        uf: state || null,
        state: state || null,
        referencePoint: referencePoint,
        enderecoCompleto: $2a5271524fdbb73b$var$buildAddressLabel(),
        address: $2a5271524fdbb73b$var$buildAddressLabel(),
        territoryId: territoryId,
        territoryLabel: territoryLabel,
        lat: $2a5271524fdbb73b$var$STATE.geo.lat ?? null,
        lng: $2a5271524fdbb73b$var$STATE.geo.lng ?? null,
        geoAddressLabel: $2a5271524fdbb73b$var$STATE.geo.addressLabel || "",
        consentLgpd: true,
        consentWhatsapp: true,
        consentImage: true,
        consentAccepted: true,
        difficulty: difficulty,
        householdMembers: householdMembers,
        projectSource: projectSource,
        projectSourceLabel: projectSourceLabel,
        projectSourceOther: projectSourceOther,
        status: "pending_approval",
        approvalStatus: "pending",
        origin: "public_form",
        source: "cadastro-publico",
        inTerritory: true,
        inOperation: false,
        active: false,
        createdAt: (0, $ilpIi.serverTimestamp)(),
        createdAtISO: new Date().toISOString()
    };
}
function $2a5271524fdbb73b$var$buildApprovalRequestPayload(participantId, participantData) {
    const territoryId = $2a5271524fdbb73b$var$getCanonicalTerritoryId();
    const territoryLabel = $2a5271524fdbb73b$var$getCanonicalTerritoryLabel();
    return {
        type: "participant_registration",
        targetCollection: "participants",
        targetId: participantId,
        territoryId: territoryId,
        territoryLabel: territoryLabel,
        participantCode: participantData.participantCode,
        participantName: participantData.name,
        participantEmail: participantData.email || null,
        participantPhone: participantData.phone,
        participantCpf: participantData.cpf || null,
        registerType: participantData.registerType,
        localType: participantData.localType,
        codeLocalType: participantData.codeLocalType,
        status: "pending",
        decision: null,
        reviewedAt: null,
        reviewedBy: null,
        reviewedByName: null,
        reviewNote: null,
        source: "cadastro-publico",
        summary: `Novo cadastro enviado por ${participantData.name} para aprova\xe7\xe3o da cooperativa.`,
        payloadSnapshot: {
            name: participantData.name,
            email: participantData.email || null,
            phone: participantData.phone,
            cpf: participantData.cpf || null,
            participantCode: participantData.participantCode,
            registerType: participantData.registerType,
            localType: participantData.localType,
            codeLocalType: participantData.codeLocalType,
            territoryId: territoryId,
            territoryLabel: territoryLabel,
            enderecoCompleto: participantData.enderecoCompleto,
            referencePoint: participantData.referencePoint,
            lat: participantData.lat ?? null,
            lng: participantData.lng ?? null,
            householdMembers: participantData.householdMembers,
            projectSource: participantData.projectSource,
            projectSourceLabel: participantData.projectSourceLabel,
            projectSourceOther: participantData.projectSourceOther
        },
        createdAt: (0, $ilpIi.serverTimestamp)(),
        createdAtISO: new Date().toISOString()
    };
}
async function $2a5271524fdbb73b$var$saveRegistration() {
    if (!$2a5271524fdbb73b$var$STATE.generatedCode || $2a5271524fdbb73b$var$STATE.generatedCode === "Ser\xe1 gerado ao concluir") {
        $2a5271524fdbb73b$var$STATE.generatedCode = await $2a5271524fdbb73b$var$generateSequentialCode();
        if ($2a5271524fdbb73b$var$els.generatedCode) $2a5271524fdbb73b$var$els.generatedCode.value = $2a5271524fdbb73b$var$STATE.generatedCode;
    }
    const participantPayload = $2a5271524fdbb73b$var$buildParticipantPayload();
    const participantRef = await (0, $ilpIi.addDoc)((0, $ilpIi.collection)((0, $bhHFP.db), "participants"), participantPayload);
    const approvalRequestPayload = $2a5271524fdbb73b$var$buildApprovalRequestPayload(participantRef.id, participantPayload);
    const approvalRef = await (0, $ilpIi.addDoc)((0, $ilpIi.collection)((0, $bhHFP.db), "approvalRequests"), approvalRequestPayload);
    return {
        participantId: participantRef.id,
        approvalRequestId: approvalRef.id,
        participantCode: participantPayload.participantCode
    };
}
/* =========================
   MODAL
========================= */ function $2a5271524fdbb73b$var$openSuccessModal() {
    if (!$2a5271524fdbb73b$var$els.successModal) return;
    $2a5271524fdbb73b$var$els.successModal.classList.remove("hidden");
    $2a5271524fdbb73b$var$els.successModal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
}
function $2a5271524fdbb73b$var$closeSuccessModal() {
    if (!$2a5271524fdbb73b$var$els.successModal) return;
    $2a5271524fdbb73b$var$els.successModal.classList.add("hidden");
    $2a5271524fdbb73b$var$els.successModal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    window.location.href = $2a5271524fdbb73b$var$CONFIG.redirectAfterSuccess;
}
/* =========================
   EVENTS
========================= */ function $2a5271524fdbb73b$var$bindConsentButton() {
    const btn = document.getElementById("btnAcceptAllConsents");
    const note = document.getElementById("consentAcceptedNote");
    btn?.addEventListener("click", ()=>{
        $2a5271524fdbb73b$var$STATE.consentAccepted = true;
        if ($2a5271524fdbb73b$var$els.consentLgpd) $2a5271524fdbb73b$var$els.consentLgpd.checked = true;
        if ($2a5271524fdbb73b$var$els.consentWhatsapp) $2a5271524fdbb73b$var$els.consentWhatsapp.checked = true;
        if ($2a5271524fdbb73b$var$els.consentImage) $2a5271524fdbb73b$var$els.consentImage.checked = true;
        btn.classList.add("is-accepted");
        btn.innerHTML = "\u2705 Autoriza\xe7\xf5es confirmadas";
        btn.disabled = true;
        if (note) {
            note.classList.remove("hidden");
            note.style.display = "flex";
        }
        $2a5271524fdbb73b$var$clearMessage();
    });
}
function $2a5271524fdbb73b$var$bindProjectSourceSelect() {
    $2a5271524fdbb73b$var$els.projectSource?.addEventListener("change", ()=>{
        if (!$2a5271524fdbb73b$var$els.projectSourceOther) return;
        if ($2a5271524fdbb73b$var$els.projectSource.value === "outro") {
            $2a5271524fdbb73b$var$els.projectSourceOther.classList.remove("hidden");
            $2a5271524fdbb73b$var$els.projectSourceOther.focus();
        } else {
            $2a5271524fdbb73b$var$els.projectSourceOther.classList.add("hidden");
            $2a5271524fdbb73b$var$els.projectSourceOther.value = "";
        }
    });
}
function $2a5271524fdbb73b$var$bindStepNavigation() {
    document.querySelectorAll("[data-next-step]").forEach((button)=>{
        button.addEventListener("click", async ()=>{
            $2a5271524fdbb73b$var$clearMessage();
            if (!$2a5271524fdbb73b$var$validateCurrentStep()) return;
            if ($2a5271524fdbb73b$var$STATE.currentStep === 3) await $2a5271524fdbb73b$var$tryGeocodeWhenReady(true);
            $2a5271524fdbb73b$var$goToStep($2a5271524fdbb73b$var$STATE.currentStep + 1);
        });
    });
    document.querySelectorAll("[data-prev-step]").forEach((button)=>{
        button.addEventListener("click", ()=>{
            $2a5271524fdbb73b$var$clearMessage();
            $2a5271524fdbb73b$var$goToStep($2a5271524fdbb73b$var$STATE.currentStep - 1);
        });
    });
}
function $2a5271524fdbb73b$var$bindLocalTypeButtons() {
    const buttons = $2a5271524fdbb73b$var$els.localTypeGroup?.querySelectorAll("[data-local-type]") || [];
    buttons.forEach((button)=>{
        button.addEventListener("click", async ()=>{
            await $2a5271524fdbb73b$var$setLocalType(button.dataset.localType);
            $2a5271524fdbb73b$var$clearMessage();
        });
    });
}
function $2a5271524fdbb73b$var$bindRegisterTypeButtons() {
    const buttons = $2a5271524fdbb73b$var$els.registerTypeGroup?.querySelectorAll("[data-register-type]") || [];
    buttons.forEach((button)=>{
        button.addEventListener("click", async ()=>{
            if (button.classList.contains("is-disabled")) return;
            await $2a5271524fdbb73b$var$setRegisterType(button.dataset.registerType, true);
            $2a5271524fdbb73b$var$clearMessage();
        });
    });
}
function $2a5271524fdbb73b$var$bindDifficultyButtons() {
    const buttons = $2a5271524fdbb73b$var$els.difficultyGroup?.querySelectorAll("[data-difficulty]") || [];
    buttons.forEach((button)=>{
        button.addEventListener("click", ()=>{
            buttons.forEach((btn)=>btn.classList.remove("selected"));
            button.classList.add("selected");
        });
    });
}
function $2a5271524fdbb73b$var$bindFormatters() {
    $2a5271524fdbb73b$var$els.phone?.addEventListener("input", (event)=>{
        event.target.value = $2a5271524fdbb73b$var$formatPhone(event.target.value);
    });
    $2a5271524fdbb73b$var$els.cpf?.addEventListener("input", (event)=>{
        event.target.value = $2a5271524fdbb73b$var$formatCPF(event.target.value);
    });
    $2a5271524fdbb73b$var$els.cep?.addEventListener("input", (event)=>{
        event.target.value = $2a5271524fdbb73b$var$formatCEP(event.target.value);
    });
}
function $2a5271524fdbb73b$var$bindGeoEvents() {
    $2a5271524fdbb73b$var$els.btnBuscarCep?.addEventListener("click", $2a5271524fdbb73b$var$handleBuscarCep);
    [
        "number",
        "street",
        "neighborhood",
        "city",
        "state",
        "cep"
    ].forEach((id)=>{
        const el = $2a5271524fdbb73b$var$$(id);
        if (!el) return;
        el.addEventListener("change", async ()=>{
            await $2a5271524fdbb73b$var$tryGeocodeWhenReady(false);
        });
        el.addEventListener("blur", async ()=>{
            await $2a5271524fdbb73b$var$tryGeocodeWhenReady(false);
        });
    });
}
function $2a5271524fdbb73b$var$bindMenu() {
    $2a5271524fdbb73b$var$els.menuToggle?.addEventListener("click", ()=>{
        $2a5271524fdbb73b$var$els.mobileMenu?.classList.toggle("show");
        $2a5271524fdbb73b$var$els.mobileMenu?.classList.toggle("open");
    });
}
function $2a5271524fdbb73b$var$bindSuccessModal() {
    $2a5271524fdbb73b$var$els.closeSuccessModal?.addEventListener("click", $2a5271524fdbb73b$var$closeSuccessModal);
    $2a5271524fdbb73b$var$els.newParticipantRegistration?.addEventListener("click", ()=>{
        window.location.reload();
    });
    $2a5271524fdbb73b$var$els.successModal?.querySelector(".success-modal-backdrop")?.addEventListener("click", $2a5271524fdbb73b$var$closeSuccessModal);
}
function $2a5271524fdbb73b$var$bindSubmit() {
    $2a5271524fdbb73b$var$els.form?.addEventListener("submit", async (event)=>{
        event.preventDefault();
        $2a5271524fdbb73b$var$clearMessage();
        if ($2a5271524fdbb73b$var$STATE.isSubmitting) return;
        if (!$2a5271524fdbb73b$var$validateStep1()) return;
        if (!$2a5271524fdbb73b$var$validateStep2()) return;
        if (!$2a5271524fdbb73b$var$validateStep3()) return;
        if (!$2a5271524fdbb73b$var$validateStep4()) return;
        $2a5271524fdbb73b$var$STATE.isSubmitting = true;
        $2a5271524fdbb73b$var$setLoading($2a5271524fdbb73b$var$els.btnSubmitParticipant, true, "Enviando cadastro...");
        try {
            await $2a5271524fdbb73b$var$tryGeocodeWhenReady(true);
            const result = await $2a5271524fdbb73b$var$saveRegistration();
            $2a5271524fdbb73b$var$showMessage(`Cadastro enviado com sucesso para an\xe1lise da cooperativa. C\xf3digo gerado: ${result.participantCode}`, "success");
            $2a5271524fdbb73b$var$openSuccessModal();
        } catch (error) {
            console.error("Erro ao salvar cadastro:", error);
            $2a5271524fdbb73b$var$showMessage(error?.message || "N\xe3o foi poss\xedvel enviar o cadastro. Verifique as regras do Firestore para participants e approvalRequests.", "error");
        } finally{
            $2a5271524fdbb73b$var$STATE.isSubmitting = false;
            $2a5271524fdbb73b$var$setLoading($2a5271524fdbb73b$var$els.btnSubmitParticipant, false);
        }
    });
}
/* =========================
   INIT
========================= */ function $2a5271524fdbb73b$var$initStaticTexts() {
    if ($2a5271524fdbb73b$var$els.territoryLabelView) $2a5271524fdbb73b$var$els.territoryLabelView.textContent = $2a5271524fdbb73b$var$getCanonicalTerritoryLabel();
    if ($2a5271524fdbb73b$var$els.userNameView) $2a5271524fdbb73b$var$els.userNameView.textContent = "Cadastro p\xfablico";
}
async function $2a5271524fdbb73b$var$initDefaults() {
    $2a5271524fdbb73b$var$STATE.consentAccepted = false;
    if ($2a5271524fdbb73b$var$els.consentLgpd) $2a5271524fdbb73b$var$els.consentLgpd.checked = true;
    if ($2a5271524fdbb73b$var$els.consentWhatsapp) $2a5271524fdbb73b$var$els.consentWhatsapp.checked = true;
    if ($2a5271524fdbb73b$var$els.consentImage) $2a5271524fdbb73b$var$els.consentImage.checked = true;
    if ($2a5271524fdbb73b$var$els.projectSourceOther) $2a5271524fdbb73b$var$els.projectSourceOther.classList.add("hidden");
    $2a5271524fdbb73b$var$updateGeoPreview();
    $2a5271524fdbb73b$var$updateProgress();
    try {
        await $2a5271524fdbb73b$var$setLocalType("casa");
    } catch (error) {
        console.warn("N\xe3o foi poss\xedvel gerar o c\xf3digo inicial:", error);
        if ($2a5271524fdbb73b$var$els.generatedCode) $2a5271524fdbb73b$var$els.generatedCode.value = "Ser\xe1 gerado ao concluir";
    }
}
async function $2a5271524fdbb73b$var$init() {
    try {
        $2a5271524fdbb73b$var$assertRuntimeConfig();
        $2a5271524fdbb73b$var$initStaticTexts();
        $2a5271524fdbb73b$var$bindConsentButton();
        $2a5271524fdbb73b$var$bindStepNavigation();
        $2a5271524fdbb73b$var$bindLocalTypeButtons();
        $2a5271524fdbb73b$var$bindRegisterTypeButtons();
        $2a5271524fdbb73b$var$bindDifficultyButtons();
        $2a5271524fdbb73b$var$bindProjectSourceSelect();
        $2a5271524fdbb73b$var$bindFormatters();
        $2a5271524fdbb73b$var$bindGeoEvents();
        $2a5271524fdbb73b$var$bindMenu();
        $2a5271524fdbb73b$var$bindSuccessModal();
        $2a5271524fdbb73b$var$bindSubmit();
        await $2a5271524fdbb73b$var$initDefaults();
    } catch (error) {
        console.error("Erro ao iniciar formul\xe1rio:", error);
        $2a5271524fdbb73b$var$showMessage(error?.message || "N\xe3o foi poss\xedvel iniciar o formul\xe1rio.", "error");
    }
}
$2a5271524fdbb73b$var$init();


//# sourceMappingURL=cadastro-participantes-vila-pinto.4dc2655f.js.map
